import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClapboardWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clapboard-wide, movie, film"><path d="M22 16.25C22 18.3211 20.3211 20 18.25 20H5.75C3.67893 20 2 18.3211 2 16.25V10.5H22V16.25Z" fill="currentColor"/><path d="M6.75098 9H2V7.75C2 5.67893 3.67893 4 5.75 4H8.41797L6.75098 9Z" fill="currentColor"/><path d="M14 9H8.33301L10 4H15.667L14 9Z" fill="currentColor"/><path d="M22 9H15.582L17.249 4H18.25C20.3211 4 22 5.67893 22 7.75V9Z" fill="currentColor"/></CentralIconBase>;
};

export default IconClapboardWide;
